// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type UmsatzListe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type SucheUmsatzQuery = {
  search?: string;
  isTaetigkeitsbericht?: boolean;
  baustellenId?: string;
  filtered?: string;
  page?: number;
  limit?: number;
  sort?: string;
  isFremdleistung?: boolean;
  startDate?: string;
  endDate?: string;
  isEntsorgungsdokumentation?: boolean;
};

export function useSucheUmsatz(): (
  query: SucheUmsatzQuery
) => Promise<UmsatzListe> {
  const getAPI = useGetApi();
  return useCallback(
    async (query = {}) => (await getAPI()).umsatz.sucheUmsatz({ ...query }),
    [getAPI]
  );
}
